import { useSelector } from 'react-redux';
import { schema, normalize } from 'normalizr';
import merge from 'lodash/fp/merge';

import { getFonts } from './selectors';

// Constants
export const ENTITIES_KEY_FONT = 'fonts';

export const SET_FONTS = 'entities/SET_FONTS';

// Schemas
export const font = new schema.Entity('fonts');

export const fontList = [font];

const normalizeFonts = (fonts) => normalize(fonts, fontList);

const getEntitiesToMerge = (normalizedFonts) =>
    merge(
        {
            entities: {
                [ENTITIES_KEY_FONT]: {
                    allIds: normalizedFonts.result,
                },
            },
        },
        normalizedFonts,
    );

// Hooks
export function useFonts() {
    return useSelector(getFonts);
}

// Actions
export const setFonts = (fonts) => ({
    type: SET_FONTS,
    payload: getEntitiesToMerge(normalizeFonts(fonts)),
});
